import React from 'react';

interface IconProps {
  width?: number;
  height?: number;
  style?: React.CSSProperties;
}

export const FaceJoyIcon: React.FC<IconProps> = ({ width = 32, height = 32, style }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path
        d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
        fill="#FFB02E"
      />
      <path
        d="M9.44719 8.10555C8.95321 7.85856 8.35254 8.05878 8.10555 8.55276C7.85856 9.04674 8.05878 9.64741 8.55276 9.8944L10.7639 11L8.55276 12.1055C8.05878 12.3525 7.85856 12.9532 8.10555 13.4472C8.35254 13.9412 8.95321 14.1414 9.44719 13.8944L13.4472 11.8944C13.786 11.725 14 11.3787 14 11C14 10.6212 13.786 10.2749 13.4472 10.1055L9.44719 8.10555Z"
        fill="#402A32"
      />
      <path
        d="M22.5528 8.10555C23.0468 7.85856 23.6475 8.05878 23.8945 8.55276C24.1414 9.04674 23.9412 9.64741 23.4472 9.8944L21.2361 11L23.4472 12.1055C23.9412 12.3525 24.1414 12.9532 23.8945 13.4472C23.6475 13.9412 23.0468 14.1414 22.5528 13.8944L18.5528 11.8944C18.214 11.725 18 11.3787 18 11C18 10.6212 18.214 10.2749 18.5528 10.1055L22.5528 8.10555Z"
        fill="#402A32"
      />
      <path d="M16 26C6 26 6 16 6 16H26C26 16 26 26 16 26Z" fill="#BB1D80" />
      <path d="M23.5 17.5H8.5C7.67157 17.5 7 16.8284 7 16H25C25 16.8284 24.3284 17.5 23.5 17.5Z" fill="white" />
    </svg>
  );
};
